module.exports = __webpack_public_path__ + "fonts/AGENCYR.70777e6b.TTF";